import Icon from "@/components/units/Icon";
import React from "react";
import { navigateToURL } from "@/utility/navigate"
import { Link } from "react-router-dom";
import ProgressRing from "@/components/units/ProgressRing/ProgressRing";
import { navigateToURLorOnboarding } from "@/utility/navigate"

const variantStyle = {
  "green-filled": "tw-bg-customCyan w-text-[#003E48]",
  "orange-filled": "tw-bg-[#FFD747] w-text-[#003E48]",
  "black-filled": "tw-bg-[#003E48] tw-text-white",
  "yellow-filled": "tw-bg-[#DBFE87] tw-text-[#003E48]",
  "orange-bordered": "tw-border tw-border-t-[4px] tw-border-t-[#FFD747] tw-text-[#001316]",
  "green-bordered": "tw-border tw-border-t-[4px] tw-border-t-customCyan tw-text-[#001316]",
  "black-bordered": "tw-border tw-border-t-[4px] tw-border-t-[#003E48] tw-text-[#001316]",
  "gray-bordered": "tw-border tw-border-t-[4px] tw-border-t-[#ACACAC] tw-text-[#001316]",
  "yellow-bordered": "tw-border tw-border-t-[4px] tw-border-t-[#DBFE87] tw-text-[#001316]",
  "purple-bordered": "tw-border tw-border-t-[4px] tw-border-t-[#E0D5F5] tw-text-[#001316]",
};

const mockData = {
  isMock: true,
  headingIcon: "stock",
  link: {},
  title: "Investment Type",
}

const InvestmentCardTitle = ({isMock, headingIcon, link, children, isDematUser=false})=>{

  const navigateToLink = (e,link) => {
    if(link.path){
      e.preventDefault();
      navigateToURLorOnboarding(link.path,isDematUser)
    } else if(!link.route){
      e.preventDefault();
    }
  }
  return (
    <div className="tw-flex tw-flex-col tw-justify-start tw-w-full">
      {
        isMock ? 
        (
          <div className={`tw-flex tw-items-center tw-gap-3 skeleton-block`}>
            { headingIcon && <Icon iconName={headingIcon} />}
            {children}
          </div>
        ) : (
          <Link className={`tw-flex tw-items-center tw-gap-3 skeleton-block`} to={link?.route} onClick={(e)=>navigateToLink(e,link)}>
            { headingIcon && <Icon iconName={headingIcon} onClick={(e)=>navigateToLink(e,link)}/>}
            {children}
          </Link>
        )
      }
  </div>
  )
}

const InvestmentCard = ({ data=mockData, onReload, isLoading, variant="green-bordered", children }) => {

  return (
    <div
      className={`tw-rounded-[16px] tw-p-5 tw-text-[18px] tw-flex tw-flex-col tw-gap-2 tw-items-center tw-min-h-[240px] max-sm:tw-min-h-[210px] ${variantStyle[variant]} ${data.isMock?'skeleton':''}`}
    >
      {
        !data.customTitle &&
          (<InvestmentCardTitle isMock={data.isMock} headingIcon={data.headingIcon} link={{route:data.route,path:data.path}} isDematUser={data.isDematUser}>
            <div className="tw-flex tw-flex-grow tw-justify-between">
              <div className="tw-flex-grow">
                {data.title}
              </div>
              {
                isLoading && <div className="tw-w-6 tw-h-6">
                  <ProgressRing
                    size={"4px"}
                    color="#75F7FF"
                    backgroundColor="#fff"
                    // inverted={true}
                    animated={true}
                    progress={0.7}
                    offset={0}
                    content=""
                  />
                </div>
              }
            </div>
          </InvestmentCardTitle>)
      }
      {
        children
      }
    </div>
  );
};

export default InvestmentCard;
